var map = {
	"./sampang/Footer.js": [
		27473,
		658,
		356
	],
	"./sampanganimation/Footer.js": [
		51935,
		881,
		935
	],
	"./sampanganimation/components/Footer/Footer.js": [
		73227,
		227
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 99272;
module.exports = webpackAsyncContext;